import { useState, useEffect } from "react";
import Axios from "axios";
import { EventDetails } from './EventDetails';
import he from 'he';

export function EventList(props){
    const handleEventChange = (event) => {
        //alert('event changed')
        //console.log(event.target.value);
        props.setcurrentEventID(event.target.value);
    }
    //
    return(
        <>
            <label for="event" class="form-label">Event</label>
            <select id="event" class="form-select mb-4 mb-md-0" aria-label="event" onChange={(event) => handleEventChange(event)}>
            <option selected>Select Event</option>
            {
                props.eventList.map( event => {
                    return(
                        <option value={event.id}>
                            {he.decode(event.title.rendered)}
                        </option>
                    )
                })
            }
            </select>
            {/*<EventDetails id={currentEventID} eventList={eventList} />*/}
        </>
    )
}